import { render, staticRenderFns } from "./SpTwoModule6.vue?vue&type=template&id=12adb7dc&scoped=true"
import script from "./SpTwoModule6.vue?vue&type=script&lang=js"
export * from "./SpTwoModule6.vue?vue&type=script&lang=js"
import style0 from "./SpTwoModule6.vue?vue&type=style&index=0&id=12adb7dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12adb7dc",
  null
  
)

export default component.exports